module.exports = __webpack_public_path__ + "static/media/Vector_Smart_Object1_lvoahj.4b95cf7b.png";